// extracted by mini-css-extract-plugin
export default {"customList":"VehicleItem_customList__5QPRR","customListImage":"VehicleItem_customListImage__0MIVt","coverImage":"VehicleItem_coverImage__Q8rmI"};